import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Packages() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-sand-light" data-id="element-187">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
        <div className="text-center mb-16" data-id="element-189">
          <h2 className="text-4xl font-heading font-bold text-ocean-dark mb-4" data-id="element-190">
            {t.packages.title}
          </h2>
          <div className="w-24 h-1 bg-turquoise mx-auto rounded-full" data-id="element-191" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-192">
          {/* Rainforest Package */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-xl border-t-4 border-rainforest" data-id="element-193">
            <div className="flex items-center gap-4 mb-6" data-id="element-194">
              <img src="https://cdn.magicpatterns.com/uploads/fDWRYDuPXFdmht4Kx9GQ1Z/ChatGPT_Image_15_jun_2026,_04_07_55_p.m..png" alt="Sweet and Salty Puerto Rico" className="h-16 w-16 object-cover rounded-2xl ring-1 ring-rainforest/20 shadow-md flex-shrink-0" data-id="element-195" />
              <h3 className="text-2xl font-heading font-bold text-rainforest-dark" data-id="element-196">
                {t.packages.rainforest.title}
              </h3>
            </div>
            <ul className="space-y-4 mb-8" data-id="element-197">
              {t.packages.rainforest.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3 text-gray-600" data-id="element-198">
                  <Check className="w-5 h-5 text-rainforest flex-shrink-0 mt-0.5" data-id="element-199" />
                  <span data-id="element-200">{feature}</span>
                </li>)}
            </ul>
            <a href="https://wa.link/ip0tbk" target="_blank" rel="noreferrer" className="block w-full text-center bg-rainforest/10 hover:bg-rainforest text-rainforest hover:text-white font-bold py-3 rounded-full transition-colors" data-id="element-201">
              {t.packages.rainforest.cta}
            </a>
          </motion.div>

          {/* Boat Package */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-ocean-dark rounded-3xl p-8 shadow-xl border-t-4 border-turquoise text-white relative overflow-hidden" data-id="element-202">
            <div className="absolute top-0 right-0 w-32 h-32 bg-turquoise/20 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-203" />
            <img src="https://cdn.magicpatterns.com/uploads/aifgHKgDB7GaFaemiHaRod/LOGO_PNG_ORIGI.png" alt="Blu Ocean Tours" className="h-20 w-auto object-contain mb-6 relative z-10 drop-shadow-[0_4px_20px_rgba(0,180,216,0.3)]" data-id="element-204" />
            <ul className="space-y-4 mb-8 relative z-10" data-id="element-205">
              {t.packages.boat.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3 text-gray-300" data-id="element-206">
                  <Check className="w-5 h-5 text-turquoise flex-shrink-0 mt-0.5" data-id="element-207" />
                  <span data-id="element-208">{feature}</span>
                </li>)}
            </ul>
            <a href="https://wa.link/qca29f" target="_blank" rel="noreferrer" className="block w-full text-center bg-turquoise hover:bg-turquoise-light text-ocean-dark font-bold py-3 rounded-full transition-colors relative z-10" data-id="element-209">
              {t.packages.boat.cta}
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}